import { jsxs, jsx } from "react/jsx-runtime";
import { formatTableLabel, getFormatDate } from "./MortgageRateTrends.utils.esm.js";
import { formatDate as format } from "../../packages/zrs-cms/node_modules/date-fns/format.esm.js";
const formatDate = getFormatDate(format);
const RateHistoryTable = ({
  program,
  stateAbbreviation,
  creditScoreBucket,
  loanAmountBucket,
  loanToValueBucket,
  samples,
  refinance,
  durationDays
}) => {
  return /* @__PURE__ */ jsxs("table", { children: [
    /* @__PURE__ */ jsx("caption", { children: formatTableLabel({
      stateAbbreviation,
      durationDays,
      loanAmountBucket,
      loanToValueBucket,
      creditScoreBucket,
      program,
      refinance
    }) }),
    /* @__PURE__ */ jsx("thead", { children: /* @__PURE__ */ jsxs("tr", { children: [
      /* @__PURE__ */ jsx("th", { children: "Date & Time;" }),
      /* @__PURE__ */ jsx("th", { children: "Percent Interest Rate;" }),
      /* @__PURE__ */ jsx("th", { children: "Annual Percentage Rate;" })
    ] }) }),
    /* @__PURE__ */ jsx("tbody", { children: samples == null ? void 0 : samples.map(({
      apr,
      rate,
      time
    }) => /* @__PURE__ */ jsxs("tr", { children: [
      /* @__PURE__ */ jsx("th", { children: `on ${formatDate(time, durationDays)}` }),
      /* @__PURE__ */ jsx("td", { children: `the rate was ${rate} percent,` }),
      /* @__PURE__ */ jsx("td", { children: `and the annual percentage rate was ${apr} percent.` })
    ] }, formatDate(time, durationDays))) })
  ] });
};
export {
  RateHistoryTable as default
};
